// Paleta curada de colores de acento para las tarjetas de receta. Tonos cuidados que se ven
// hermosos y on-brand sobre la tarjeta tipo "receta impresa" (foto + cabeceras + banda de pie).
const RECIPE_COLORS = [
  { value: '#2F8C84', name: 'teal' },
  { value: '#C26B4A', name: 'terracotta' },
  { value: '#6E7B3D', name: 'olive' },
  { value: '#C99A2E', name: 'mustard' },
  { value: '#7C3047', name: 'wine' },
  { value: '#2E4E6E', name: 'navy' },
  { value: '#4A5560', name: 'slate' },
  { value: '#9A6B00', name: 'gold' }
];

export const DEFAULT_RECIPE_COLOR = RECIPE_COLORS[0].value;

export default RECIPE_COLORS;
